module.exports = "/images/o-logo-white-mobile.svg?1e490632d9dd0cc1dea4eece92cd2e41";